import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React, { useCallback, useContext, useEffect } from 'react';
import classNames from 'classnames';
import ConfigContext from '../config-provider/ConfigContext';
import { getCompProps } from '../_utils';
import Checkbox from './../checkbox';
import Icon from '../icon';
import Spin from '../spin';
var TreeNode = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _context;

  var _useContext = useContext(ConfigContext),
      getPrefixCls = _useContext.getPrefixCls,
      prefixCls = _useContext.prefixCls,
      userDefaultProps = _useContext.compDefaultProps;

  var TreeNodeProps = getCompProps('TreeNode', userDefaultProps, props); // 按钮属性需要合并一遍用户定义的默认属性

  var nodeKey = TreeNodeProps.nodeKey,
      customPrefixcls = TreeNodeProps.prefixCls,
      selectable = TreeNodeProps.selectable,
      checkable = TreeNodeProps.checkable,
      className = TreeNodeProps.className,
      icon = TreeNodeProps.icon,
      switcherIcon = TreeNodeProps.switcherIcon,
      disabled = TreeNodeProps.disabled,
      draggable = TreeNodeProps.draggable,
      pos = TreeNodeProps.pos,
      checked = TreeNodeProps.checked,
      level = TreeNodeProps.level,
      getDragNode = TreeNodeProps.getDragNode,
      hasChildNode = TreeNodeProps.hasChildNode,
      expand = TreeNodeProps.expand,
      title = TreeNodeProps.title,
      showLine = TreeNodeProps.showLine,
      showIcon = TreeNodeProps.showIcon,
      selected = TreeNodeProps.selected,
      setDragNode = TreeNodeProps.setDragNode,
      style = TreeNodeProps.style,
      indeterminate = TreeNodeProps.indeterminate,
      estimatedItemSize = TreeNodeProps.estimatedItemSize,
      dragOver = TreeNodeProps.dragOver,
      expandOnClickNode = TreeNodeProps.expandOnClickNode,
      loading = TreeNodeProps.loading,
      onExpand = TreeNodeProps.onExpand,
      onCheck = TreeNodeProps.onCheck,
      onDragStart = TreeNodeProps.onDragStart,
      onDragOver = TreeNodeProps.onDragOver,
      onDragLeave = TreeNodeProps.onDragLeave,
      onDragEnter = TreeNodeProps.onDragEnter,
      onDragEnd = TreeNodeProps.onDragEnd,
      onDrop = TreeNodeProps.onDrop,
      onSelect = TreeNodeProps.onSelect,
      others = __rest(TreeNodeProps, ["nodeKey", "prefixCls", "selectable", "checkable", "className", "icon", "switcherIcon", "disabled", "draggable", "pos", "checked", "level", "getDragNode", "hasChildNode", "expand", "title", "showLine", "showIcon", "selected", "setDragNode", "style", "indeterminate", "estimatedItemSize", "dragOver", "expandOnClickNode", "loading", "onExpand", "onCheck", "onDragStart", "onDragOver", "onDragLeave", "onDragEnter", "onDragEnd", "onDrop", "onSelect"]);

  var nodeData = React.useMemo(function () {
    return _extends({
      selectable: selectable,
      checkable: checkable,
      expand: expand,
      key: nodeKey,
      level: level,
      title: title,
      disabled: disabled,
      draggable: draggable,
      checked: checked,
      pos: pos,
      hasChildNode: hasChildNode,
      indeterminate: indeterminate,
      icon: icon,
      switcherIcon: switcherIcon,
      showIcon: showIcon,
      selected: selected
    }, others);
  }, [selectable, checkable, expand, nodeKey, level, title, disabled, draggable, checked, pos, hasChildNode, indeterminate, icon, switcherIcon, showIcon, selected]);

  var useExpand = function useExpand(value) {
    var _React$useState = React.useState(value),
        _React$useState2 = _slicedToArray(_React$useState, 2),
        expand = _React$useState2[0],
        setExpand = _React$useState2[1];

    var setExpandState = function setExpandState(value) {
      return setExpand(value);
    };

    useEffect(function () {
      setExpand(value);
    }, [value]);
    return [expand, setExpandState];
  };

  var dragRef = React.useRef(null);

  var _useExpand = useExpand(expand),
      _useExpand2 = _slicedToArray(_useExpand, 2),
      expandState = _useExpand2[0],
      setExpandState = _useExpand2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      showDragLine = _React$useState4[0],
      setShowDragLine = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      forbiddenChildrenPointerEvents = _React$useState6[0],
      setForbiddenChildrenPointerEvents = _React$useState6[1];

  var treeNodePrefixCls = getPrefixCls(prefixCls, 'tree-node', customPrefixcls); // 按钮样式前缀

  var renderIcon = function renderIcon(icon) {
    if (typeof icon === 'function') {
      var nodeProps = {
        selectable: selectable,
        checkable: checkable,
        disabled: disabled,
        title: title,
        draggable: draggable,
        checked: checked,
        hasChildNode: hasChildNode,
        expand: expand,
        nodeKey: nodeKey,
        icon: icon,
        switcherIcon: switcherIcon,
        showIcon: showIcon,
        selected: selected,
        indeterminate: indeterminate
      };
      return icon(_extends({}, nodeProps));
    }

    return icon;
  };

  var indent = function indent() {
    var _classNames;

    var indentArr = [];
    var className = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(treeNodePrefixCls, "-indent"), true), _defineProperty(_classNames, "".concat(treeNodePrefixCls, "-indent-line"), !!showLine), _classNames));

    for (var i = 0; i < level; i++) {
      indentArr.push( /*#__PURE__*/React.createElement("span", {
        className: className,
        key: i,
        style: {
          height: "".concat(estimatedItemSize)
        }
      }, "\xA0\xA0\xA0\xA0"));
    }

    return indentArr;
  };

  var isLeaf = useCallback(function () {
    var isLeaf = TreeNodeProps.isLeaf,
        loadData = TreeNodeProps.loadData,
        hasChildNode = TreeNodeProps.hasChildNode;

    if (isLeaf === false) {
      return false;
    }

    return isLeaf || !loadData && !hasChildNode;
  }, [TreeNodeProps]); // line的两种模式， 图标被替换和图标不被替换

  var renderExpandIcon = function renderExpandIcon() {
    if (loading) {
      return /*#__PURE__*/React.createElement(Spin, {
        type: "component"
      });
    }

    var showExpandIcon = !isLeaf();

    if (showExpandIcon) {
      var _classNames3;

      if (Array.isArray(switcherIcon) && switcherIcon.length === 2) {
        return /*#__PURE__*/React.createElement("span", {
          className: classNames("".concat(treeNodePrefixCls, "-icon"), _defineProperty({}, "".concat(treeNodePrefixCls, "-icon-hover"), !expandOnClickNode)),
          onClick: expandOnClickNode ? undefined : handleExpandIconClick
        }, expandState ? renderIcon(switcherIcon[1]) : renderIcon(switcherIcon[0]));
      }

      return /*#__PURE__*/React.createElement("span", {
        className: classNames("".concat(treeNodePrefixCls, "-icon"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(treeNodePrefixCls, "-animation-expand"), expandState), _defineProperty(_classNames3, "".concat(treeNodePrefixCls, "-animation-collapse"), !expandState), _defineProperty(_classNames3, "".concat(treeNodePrefixCls, "-icon-hover"), !expandOnClickNode), _classNames3)),
        onClick: expandOnClickNode ? undefined : handleExpandIconClick
      }, renderIcon(switcherIcon || /*#__PURE__*/React.createElement(Icon, {
        type: "arrow-right-solid"
      })));
    } else {
      // 叶子结点 隐藏展开按钮
      return /*#__PURE__*/React.createElement("span", {
        className: "".concat(treeNodePrefixCls, "-icon-hidden")
      });
    }
  };

  var renderNodeIcon = function renderNodeIcon() {
    return /*#__PURE__*/React.createElement("span", {
      className: "".concat(treeNodePrefixCls, "-leaf-icon")
    }, renderIcon(icon));
  };

  var renderNode = function renderNode() {
    var _classNames4, _classNames5;

    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      draggable: draggable && !disabled,
      className: classNames((_classNames4 = {}, _defineProperty(_classNames4, "".concat(treeNodePrefixCls, "-draggabled"), true), _defineProperty(_classNames4, "".concat(treeNodePrefixCls, "-root"), true), _defineProperty(_classNames4, "".concat(treeNodePrefixCls, "-fb-children-pointerEvents"), forbiddenChildrenPointerEvents), _defineProperty(_classNames4, "".concat(treeNodePrefixCls, "-drag-over"), dragOver), _classNames4)),
      onDragStart: handleDragStart,
      onDragEnd: handleDragEnd,
      onDragOver: handleDragOver,
      onDragLeave: handleDragLeave,
      onDragEnter: handleDragEnter,
      onDrop: handleDrop,
      ref: dragRef
    }, indent(), renderExpandIcon(), showIcon && renderNodeIcon(), /*#__PURE__*/React.createElement("div", {
      className: classNames((_classNames5 = {}, _defineProperty(_classNames5, "".concat(treeNodePrefixCls, "-title-wrap"), true), _defineProperty(_classNames5, "".concat(treeNodePrefixCls, "-title-wrap-hover"), !expandOnClickNode && !disabled), _defineProperty(_classNames5, "".concat(treeNodePrefixCls, "-title-wrap-selected"), selected && selectable && !disabled && !expandOnClickNode), _classNames5)),
      onClick: expandOnClickNode ? undefined : handleClick
    }, checkable ? /*#__PURE__*/React.createElement(Checkbox, {
      onChange: handleOnchange,
      checked: checked,
      indeterminate: !disabled && indeterminate,
      disabled: disabled,
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: classNames("".concat(treeNodePrefixCls, "-title"), _defineProperty({}, "".concat(treeNodePrefixCls, "-title-disabled"), disabled))
    }, title)) : /*#__PURE__*/React.createElement("span", {
      className: classNames("".concat(treeNodePrefixCls, "-title"), _defineProperty({}, "".concat(treeNodePrefixCls, "-title-disabled"), disabled))
    }, title), showDragLine && !dragOver && /*#__PURE__*/React.createElement("span", {
      className: classNames("".concat(treeNodePrefixCls, "-drag-line"))
    }))));
  };

  var handleOnchange = React.useCallback(function (e) {
    var value = e.target.checked;
    onCheck && onCheck(nodeKey, value, nodeData, e, pos);
  }, [onCheck, nodeKey, nodeData, pos]);
  var handleSelect = React.useCallback(function (e) {
    selectable && !disabled && onSelect && onSelect(e, nodeData, nodeKey);
  }, [onSelect, selectable, disabled, nodeData, nodeKey]);
  React.useImperativeHandle(ref, function () {
    return {
      selectNode: handleSelect
    };
  });
  var handleExpandIconClick = useCallback(function (e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    setExpandState(!expandState);
    onExpand && onExpand(nodeKey, !expandState, nodeData);
  }, [expandState, nodeData, nodeKey, onExpand, setExpandState]);
  var handleClick = React.useCallback(function (e) {
    e.stopPropagation();
    expandOnClickNode && handleExpandIconClick();
    handleSelect(e);
  }, [expandOnClickNode, handleExpandIconClick, handleSelect]);
  var handleDragStart = React.useCallback(function (e) {
    if (!draggable) return;
    setDragNode(nodeData);
    onDragStart && onDragStart(e, props);
  }, [draggable, setDragNode, nodeData, onDragStart, props]);
  var handleDragOver = React.useCallback(function (e) {
    if (!draggable) return;
    e.preventDefault();
    onDragOver && onDragOver(e, nodeData, dragRef.current);
  }, [onDragOver, nodeData, draggable]);
  var handleDragLeave = React.useCallback(function (e) {
    var _a;

    if (!draggable) return;
    if (!((_a = dragRef.current) === null || _a === void 0 ? void 0 : _a.isEqualNode(e.target))) return;
    setForbiddenChildrenPointerEvents(false);
    setShowDragLine(false);
    onDragLeave && onDragLeave(e, nodeData);
  }, [onDragLeave, nodeData, draggable]);
  var handleDragEnter = React.useCallback(function (e) {
    var _a;

    if (!draggable) return;
    setForbiddenChildrenPointerEvents(true);
    if (!((_a = dragRef.current) === null || _a === void 0 ? void 0 : _a.isEqualNode(e.target))) return;
    setShowDragLine(true);
    onDragEnter && onDragEnter(e, nodeData, dragRef.current);
  }, [onDragEnter, nodeData, draggable]);
  var handleDragEnd = React.useCallback(function (e) {
    if (!draggable) return;
    onDragEnd && onDragEnd(e, nodeData);
    setDragNode(undefined);
  }, [onDragEnd, nodeData, draggable]);
  var handleDrop = React.useCallback(function (e) {
    if (!draggable) return;
    setShowDragLine(false);
    var data = getDragNode();
    var sourceKey = data === null || data === void 0 ? void 0 : data.key;

    if (sourceKey) {
      var targetKey = nodeKey;

      if (targetKey !== sourceKey) {
        onDrop && onDrop(e, nodeData, data, sourceKey);
      }
    }
  }, [onDrop, nodeData, nodeKey]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("".concat(treeNodePrefixCls, "-item"), _defineProperty({}, "".concat(treeNodePrefixCls, "-item-hover"), !disabled && selectable && expandOnClickNode), _defineProperty({}, "".concat(treeNodePrefixCls, "-selected"), selected && selectable && !disabled && expandOnClickNode), _defineProperty({}, "".concat(treeNodePrefixCls, "-disabled"), disabled), _defineProperty({}, "".concat(treeNodePrefixCls, "-opened"), expandState), _concatInstanceProperty(_context = "".concat(treeNodePrefixCls, "-item-")).call(_context, nodeKey), className),
    style: _extends({
      height: "".concat(estimatedItemSize, "px")
    }, style),
    onClick: expandOnClickNode ? handleClick : undefined
  }, renderNode());
});
TreeNode.displayName = 'TreeNode';
export default TreeNode;